import * as React from 'react'
import { cn } from '@/lib/utils'
import { Badge } from './badge'

interface EditorStatsProps extends React.HTMLAttributes<HTMLDivElement> {
  unsettledCount?: number | null
}

export const EditorStats = React.forwardRef<HTMLDivElement, EditorStatsProps>(
  ({ unsettledCount, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-xl border bg-card text-card-foreground shadow px-3 py-2 text-sm w-fit',
        className,
      )}
      {...props}
    >
      <div className="flex items-center gap-2">
        <span className="font-medium">Rendezetlen</span>
        <Badge variant="secondary">{unsettledCount ?? 'n/a'}</Badge>
      </div>
    </div>
  ),
)
EditorStats.displayName = 'EditorStats'
